import { defineStore } from 'pinia'
import type { SystemInfo, AppConfig } from '../types/store'
import $api from '@/api/index'

interface AppState {
  systemInfo: SystemInfo | null
  navBarHeight: number
  statusBarHeight: number
  safeAreaBottom: number
  config: AppConfig
  platformChecking: boolean
  regionList: any[]
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    // 系统信息
    systemInfo: null,
    // 导航栏高度
    navBarHeight: 0,
    // 状态栏高度
    statusBarHeight: 0,
    // 底部安全区域高度
    safeAreaBottom: 0,
    // 全局配置
    config: {
      // API基础路径
      baseUrl: '',
      // 上传文件路径
      uploadUrl: '',
      // 静态资源路径
      staticUrl: ''
    },
    platformChecking: false,
    // 地区列表
    regionList: uni.getStorageSync('regionList') || []
  }),

  getters: {
    // 获取状态栏和导航栏总高度
    navigationBarHeight: (state: AppState): number => {
      return state.statusBarHeight + state.navBarHeight
    }
  },

  actions: {
    // 初始化系统信息
    initSystemInfo(): void {
      try {
        $api.common.getConfig({}).then((res) => {
          this.platformChecking = res.data.version
        })
        const systemInfo = uni.getSystemInfoSync()
        this.systemInfo = systemInfo
        this.statusBarHeight = systemInfo.statusBarHeight || 0
        this.safeAreaBottom = systemInfo.safeAreaInsets?.bottom || 0

        // 根据平台设置导航栏高度
        // #ifdef MP
        this.navBarHeight = 44
        // #endif
        // #ifdef H5
        this.navBarHeight = 44
        // #endif
      } catch (e) {
        console.error('获取系统信息失败', e)
      }
    },

    initRegion(): void {
      if (this.regionList.length == 0) {
        $api.common.getRegionTotalList({}).then((res) => {
          this.regionList = res.data
          uni.setStorageSync('regionList', this.regionList)
        })
      }
    },

    // 设置配置信息
    setConfig(config: Partial<AppConfig>): void {
      this.config = {
        ...this.config,
        ...config
      }
    }
  }
})
